import {GetArticleResponse} from '@dms/api/warehouse';
import {usePermissions} from '@dms/shared';

import {Nullish} from 'shared/web';

import {getArticleAllowedPermissions} from '../utils/getArticleAllowedPermissions';

/**
 * @about Combine the `articleEdit` role permission with the warehouse ACL scopes of the article.
 */
export function useArticleAllowedPermissions(article: GetArticleResponse | Nullish) {
  const [articleEdit] = usePermissions({permissionKeys: ['articleEdit']});
  const allowedPermissions = getArticleAllowedPermissions(article);

  return {...allowedPermissions, canEdit: articleEdit && allowedPermissions.canEdit};
}
